import EncryptInput from "./EncryptInput"

export default EncryptInput